import { render, staticRenderFns } from "./TradingPolicyList.vue?vue&type=template&id=462a904b"
import script from "./TradingPolicyList.vue?vue&type=script&lang=ts"
export * from "./TradingPolicyList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports